import axiosClient, { ApiResponse, axiosCustomError } from "./axiosClient"

export interface IIssueInvoiceLog {
    id: number
    orderId: number
    orderType: string
    message: string
    logDetails: string
    providerId: number
    createdOn: Date
}

export default class IssueInvoiceLogService {
    static async filter(providerId: number, pageIndex: number, pageSize: number, keyword: string) {
        try {
            const { data } = await axiosClient.get<ApiResponse>(`/api/IssueInvoiceLogs/${providerId}?keyword=${keyword}&pageSize=${pageSize}&pageIndex=${pageIndex}`)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async get(providerId: number, id: number) {
        try {
            const { data } = await axiosClient.get<ApiResponse>(`/api/IssueInvoiceLogs/${providerId}/${id}`)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async delete(providerId: number, id: number) {
        try {
            const { data } = await axiosClient.delete<ApiResponse>(`/api/IssueInvoiceLogs/${providerId}/${id}`, {

            })

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async clear(providerId: number) {
        try {
            const { data } = await axiosClient.delete<ApiResponse>(`/api/IssueInvoiceLogs/${providerId}/Clear`, {

            })

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }
}